import React, { ReactElement } from 'react';
import { useLocation } from 'react-router';
import Layout from '../Layout';
import SendPripomienky from '../../module/SendPripomienky/SendPripomienky';
import useSendPripomienkaList from '../../module/SendPripomienky/hook/useSendPripomienkaList';
import routes from '../../routing/routes';
import UserRole from '../../model/currentuser/UserRole';
import { canSendErrorConditions } from '../../function/permissions';
import SecuredPage from '../../module/SecuredPage';
import { useUserContext } from '../../context/UserContext';

export default (): ReactElement => {
  const {
    pripomienkyForSend,
    pripomienkaStatus,
  } = useSendPripomienkaList();
  const { pathname } = useLocation();
  const {
    pouzivatel,
    legislationProcess,
  } = useUserContext();

  return (
    <Layout
      breadcrumbRouteList={[{
        heading: routes.sendPripomienky.name,
        to: pathname,
      }]}
    >
      <SecuredPage
        allowForRoles={[UserRole.NELEGISLATIVNA_ORGANIZACIA, UserRole.ODOSIELATEL]}
        errorPageConditions={canSendErrorConditions(pouzivatel, legislationProcess)}
        requestStatuses={[pripomienkaStatus?.responseCode]}
      >
        <SendPripomienky
          pripomienkyForSend={pripomienkyForSend}
          status={pripomienkaStatus}
        />
      </SecuredPage>
    </Layout>
  );
};
